/* eslint-disable @typescript-eslint/naming-convention */
import { generalSetting } from 'src/app/core/settings/general.settings';

export const environment = {
  production: true,
  // API_BASE_URL: 'http://localhost:7000',
  API_BASE_URL: 'https://rekruting.piima.uz',
  maxUploadFileSize: 50000000,
  ...generalSetting,

  response_type: 'one_code',
  client_id: 'vacancy_piima_uz',
  redirect_uri: 'https://vacancy.piima.uz/#/oneid?localredirectUrl=',
  scope: 'vacancy_piima_uz',
  state: '{"method":"IDPW"}'
};
